import type { ReceiptTemplate } from '../schema';

export const burgerKingTemplate: ReceiptTemplate = {
  id: 'burger-king',
  name: 'Burger King Receipt',
  brand: 'BURGER KING',
  description: 'Fast food restaurant receipt template',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'narrow',
  },
  sections: [
    {
      id: 'bk-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/burger-king.png',
        logoData: '',
        logoWidth: 120,
        logoHeight: 60,
        businessName: '',
        businessNameFontSize: 20,
        addressLines: [
          '#12847',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'bk-order',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'ORDER #284',
        fontSize: 18,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: true,
      },
    },
    {
      id: 'bk-trans',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'CARRY OUT\n01/04/26 13:42  REG 01  JAMES',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'bk-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: true,
        showPrice: true,
        showTotal: false,
        items: [
          { id: 'bk-item-1', name: 'WHOPPER MEAL', quantity: '1', price: '11.49'},
          { id: 'bk-item-2', name: '  MED FRIES', quantity: '1', price: '0.00'},
          { id: 'bk-item-3', name: '  MED DRINK', quantity: '1', price: '0.00'},
          { id: 'bk-item-4', name: 'CHICKEN FRIES', quantity: '1', price: '4.29'},
          { id: 'bk-item-5', name: 'HERSHEY PIE', quantity: '1', price: '2.49'},
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'bk-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 35,
        labelAlignment: 'left',
        lines: [
          { id: 'bk-subtotal', label: 'SUBTOTAL', value: '18.27', isBold: false, isLarge: false },
          { id: 'bk-tax', label: 'TAX', value: '1.62', isBold: false, isLarge: false },
          { id: 'bk-total', label: 'TOTAL', value: '19.89', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 20,
        showDivider: true,
        dividerStyle: 'double',
      },
    },
    {
      id: 'bk-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        paymentType: 'card',
        cardFields: [
          { id: 'bk-card', label: 'MASTERCARD', value: '************4144' },
          { id: 'bk-auth', label: 'AUTH', value: '284719' },
        ],
        cashFields: [],
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'bk-barcode',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'code128',
        value: '12847284010426',
        showValue: false,
        width: 1.5,
        height: 35,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'bk-survey',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'MYBKEXPERIENCE.COM\nTAKE OUR SURVEY\nWIN A FREE WHOPPER!\n\nHAVE IT YOUR WAY',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
};

